import { groupBy } from './tools/collections/group_by';
import { each } from './tools/collections/each';
import { filter } from './tools/collections/filter';
import { map } from './tools/collections/map';
import { reduce } from './tools/collections/reduce';
import { sortBy } from './tools/collections/sort_by';
import { first } from './tools/collections/first';
import { last } from './tools/collections/last';
import { at } from './tools/collections/at';
import { keys } from './tools/collections/keys';

import { identity } from './tools/functions/identity';

import { clone } from './tools/objects/clone';
import { deepClone } from './tools/objects/deep_clone';
import { get, getWithDefault } from './tools/objects/get';
import { merge } from './tools/objects/merge';
import { mergeWith } from './tools/objects/merge_with';
import { set } from './tools/objects/set';

import { capitalize } from './tools/strings/capitalize';
import {
  camelToKebabCase,
  kebabToCamelCase,
  kebabToPascalCase,
  kebabToSnakeCase,
  pascalToKebabCase,
  snakeToKebabCase
} from './tools/strings/convert_case';
import { uncapitalize } from './tools/strings/uncapitalize';

import { isEmpty } from './tools/util/is_empty';
import { isNil } from './tools/util/is_nil';
import { is } from './tools/util/is';
import { uniqueId } from './tools/util/unique_id';

const tt = {
  camelToKebabCase,
  capitalize,
  clone,
  deepClone,
  each,
  filter,
  get,
  getWithDefault,
  groupBy,
  identity,
  isEmpty,
  isNil,
  is,
  kebabToCamelCase,
  kebabToPascalCase,
  kebabToSnakeCase,
  map,
  merge,
  mergeWith,
  pascalToKebabCase,
  reduce,
  keys,
  set,
  snakeToKebabCase,
  sortBy,
  first,
  last,
  at,
  uncapitalize,
  uniqueId
};

export default tt;
